import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\UpdateImportTaskSyncAutoController::__invoke
* @see app/Http/Controllers/Import/UpdateImportTaskSyncAutoController.php
* @route '/api/import/{import}/task/{importTask}/sync-auto'
*/
const UpdateImportTaskSyncAutoController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateImportTaskSyncAutoController.url(args, options),
    method: 'patch',
})

UpdateImportTaskSyncAutoController.definition = {
    methods: ["patch"],
    url: '/api/import/{import}/task/{importTask}/sync-auto',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Import\UpdateImportTaskSyncAutoController::__invoke
* @see app/Http/Controllers/Import/UpdateImportTaskSyncAutoController.php
* @route '/api/import/{import}/task/{importTask}/sync-auto'
*/
UpdateImportTaskSyncAutoController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return UpdateImportTaskSyncAutoController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\UpdateImportTaskSyncAutoController::__invoke
* @see app/Http/Controllers/Import/UpdateImportTaskSyncAutoController.php
* @route '/api/import/{import}/task/{importTask}/sync-auto'
*/
UpdateImportTaskSyncAutoController.patch = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateImportTaskSyncAutoController.url(args, options),
    method: 'patch',
})

export default UpdateImportTaskSyncAutoController